import styled from '@emotion/styled';
import { opacify } from 'polished';

import {
  dimensions,
  colors,
  breakpoints,
  hiddenWhenSmall,
} from '@parapet/common';
import { PublicComponentContent } from '../Public/styles';

export const LoginContainer = styled.div`
  > div {
    background-color: ${colors.gray.dark};
    height: 100vh;
    position: relative;
    @media (max-width: ${breakpoints.lg}) {
      height: auto;
    }
  }
  h4 {
    text-align: center;
    margin: 10px 0 ${dimensions.spacer} 0;
    color: #fff9;
  }
  form {
    position: relative;
    z-index: 1;
    input {
      color: ${opacify(-0.4, colors.white)};
      &:focus {
        color: ${colors.white};
        ::placeholder {
          color: ${colors.white};
        }
      }
      ::placeholder {
        color: ${opacify(-0.8, colors.white)};
      }
    }
    button[type='submit'] {
      height: auto;
      padding-top: 11px;
      padding-bottom: 11px;
      font-size: ${dimensions.fontSize.medium + 2}px;
    }
  }
  .Logo {
    width: 140px;
    fill: ${colors.gray.calm};
    position: relative;
    left: 50%;
    top: -40px;
    margin-left: -70px;
    z-index: 1;
    @media (max-width: ${breakpoints.lg}) {
      min-width: 140px;
    }
  }
`;

export const LoginContent = styled(PublicComponentContent)`
  background-color: ${opacify(1, colors.gray.dark)};
  box-shadow: 0 4px 40px -4px #0003;
  border-radius: var(--border-radius-lg);
  width: 460px;
  padding: ${dimensions.spacerLarge};
  position: relative;
  z-index: 9;
  @media (max-width: ${breakpoints.lg}) {
    padding: ${dimensions.spacer};
  }
  &:before {
    content: '';
    width: 600px;
    height: 600px;
    opacity: 0.2;
    background-color: ${colors.brand};
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 0;
    margin: -300px 0 0 -300px;
    border-radius: 1000px;
    filter: blur(100px);
    animation: fadeIn 1s ease;
    ${hiddenWhenSmall};
  }
  &:after {
    content: '';
    background-color: ${colors.gray.dark};
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: var(--border-radius-lg);
    opacity: 0.8;
  }
`;

export const LoginFooter = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  z-index: 8;
  &:hover {
    z-index: 10;
  }
`;

export const LoginFooterLink = styled.div`
  margin-top: ${dimensions.spacer};
  position: relative;
  z-index: 9;
  > a {
    opacity: 0.6;
    font-size: ${dimensions.fontSize.small}px;
    color: ${colors.white};
    padding: 12px 24px;
    border: 1px solid transparent;
    border-radius: 100px;
    &:hover {
      opacity: 1;
      text-decoration: none;
      border-color: ${opacify(-0.88, colors.white)};
    }
  }
`;

// export const MaintenanceMessage = styled.div`
//   width: 440px;
//   font-size: ${dimensions.fontSize.medium + 2}px;
//   text-align: center;
//   color: #fff;
//   padding-top: ${dimensions.spacer};
//   @media (max-width: ${breakpoints.lg}) {
//     width: 100%;
//   }
// `;
